export function LeadCommissionTile({ summary }) {
  if (!summary) return null;
  const total = (summary.commission_earned || 0) + (summary.commission_pending || 0);
  const pct = total ? Math.round(((summary.commission_paid || 0) / total) * 100) : 0;
  return (
    <div className="bg-igc-surface border border-igc-gold/15 p-6 mb-6" data-testid="lead-commission-tracker-tile">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-4" title="Tracks commission on every deal this lead is tied to — how much you've earned, what's still pending a decision, and how much has actually been paid.">Commission Tracker</p>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <p className="font-serif text-2xl text-igc-cream" data-testid="commission-tile-earned" title="Total commission earned so far on this lead's deals.">${(summary.commission_earned || 0).toLocaleString()}</p>
          <p className="text-igc-muted text-[10px] mt-1">Earned</p>
        </div>
        <div>
          <p className="font-serif text-2xl text-igc-goldText" data-testid="commission-tile-pending" title="Commission still waiting on a decision before it's paid.">${(summary.commission_pending || 0).toLocaleString()}</p>
          <p className="text-igc-muted text-[10px] mt-1">Pending</p>
        </div>
        <div>
          <p className="font-serif text-2xl text-igc-success" data-testid="commission-tile-paid" title="Commission that has actually been paid out.">${(summary.commission_paid || 0).toLocaleString()}</p>
          <p className="text-igc-muted text-[10px] mt-1">Paid Out</p>
        </div>
      </div>
      <div className="h-2 bg-igc-surfaceLight overflow-hidden" title={`${pct}% of total commission has been paid out.`}>
        <div className="h-full bg-igc-success transition-all" style={{ width: `${pct}%` }} data-testid="commission-tile-progress-bar" />
      </div>
      <p className="text-igc-muted text-[10px] mt-2">{pct}% of total commission has been paid out</p>
    </div>
  );
}
